import { usePersonDetailContext } from '../contexts/PersonDetailContext';

export const usePersonDetail = () => {
  const { openPersonDetail, closePersonDetail } = usePersonDetailContext();

  return {
    openPersonDetail,
    closePersonDetail,
  };
};
